'use client';
import NextLink from '@/components/next-link';
import { event_top_nav_clicked, event_button_click } from '@/utils/gtm';
import { useLocale, useTranslations } from 'next-intl';
import { usePathname } from 'next/navigation';

const Categories = () => {
  const t = useTranslations('common');
  const locale = useLocale();
  const pathname = usePathname();

  const isActive =
    locale === 'en' ? pathname.split('/')[2] : pathname.split('/')[1];

  return (
    <div>
      <NextLink
        href={'/categories'}
        onClick={() => {
          event_top_nav_clicked({ menu_name: t('Shop By Category') });
          event_button_click({
            button_name: 'Shop By Category',
            button_destination: '/categories',
            button_location: 'header',
          });
        }}
        className='max-sm:text-primary flex items-center gap-3 text-sm capitalize max-md:text-sm max-sm:text-xs'
      >
        <span
          className={`whitespace-nowrap ${isActive === 'categories' ? 'text-primary border-primary border-b font-bold' : ''}`}
        >
          {t('Shop By Category')}
        </span>
      </NextLink>
    </div>
  );
};

export default Categories;
